import VxeTable from './src/index'

VxeTable.install = function (Vue) {
  Vue.component(VxeTable.name, VxeTable)
}

export default VxeTable
